var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"amount-box"},[_c('i',{staticClass:"currency",style:(_vm.currencyStyle)},[_vm._v(_vm._s(_vm.currencyCode))]),_c('i',{staticClass:"amount",style:(_vm.amountStyle)},[_vm._v(_vm._s(_vm.amountYuan))])])
}
var staticRenderFns = []

export { render, staticRenderFns }